import React from "react";
import LocalizedWeatherGuidePage from "@/components/weather/LocalizedWeatherGuidePage";

export default function BeaufortGuide() {
  return <LocalizedWeatherGuidePage guideKey="beaufort" />;
}